import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketType } from '../types';

import { Ticket } from './ticket';

const _schema = {
    "name": "TICKETMIXEDPAY",
    "fields": [
        { name: "ticket", type: "objid" },
        { name: "payment", type: "string" },                
        { name: "amount", type: "number" },
        { name: "partial", type: "boolean", default: "0" }
    ],
    relate: [
        { direction: ">", target: "TICKET", by: "ticket", name: "ticket", reason: "ticket", child: false, class: TicketType },
    ]
} as const;

const _MixedPaymentClass = CreateObject(_schema);
if (!_MixedPaymentClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class MixedPayment extends _MixedPaymentClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): MixedPayment {
        return this._Copy(store) as MixedPayment;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || relation !== 'ticket' || !(related instanceof Ticket)){
            return;
        }

        if (related === this.ticket){
            related.AddMixed(this);
        }
        else {
            related.DelMixed(this);
        }
    }
}

